import { axiosDS, CONTOUR, getContour } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Src/constants/Urls'
import { ArticleModel } from 'Pages/knowledge'

export const articleApi = {
	getAllArticleApi: async (idProject?: number, params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ArticleModel>>(
			`${urls.knowledge.project}/${idProject}/article`,
			{ params }
		)
		return res.data
	},
	getOneArticleApi: async (idProject: number, idArticle: number) => {
		const res = await axiosDS().get<ArticleModel>(
			`${urls.knowledge.project}/${idProject}/article/${idArticle}/edit`
		)
		return res.data
	},
	viewArticleApi: async (slugProject: string, slugArticle: string) => {
		const res = await axiosDS().get<ArticleModel>(
			`${urls.knowledge.project}/${slugProject}/article/${slugArticle}`
		)
		return res.data
	},
	previewArticleApi: async (idProject: number, idArticle: number) => {
		const res = await axiosDS().get<ArticleModel>(
			`${urls.knowledge.project}/${idProject}/article/${idArticle}/preview`
		)
		return res.data
	},
	createArticleApi: async (data: { data: ArticleModel } | FormData, idProject: number) => {
		const res = await axiosDS({ timeout: 0 }).post<ArticleModel>(
			`${urls.knowledge.project}/${idProject}/article`,
			data
		)
		return res.data
	},
	updateArticleApi: async (
		data: { data: ArticleModel } | FormData,
		idProject: number,
		idArticle: number
	) => {
		const res = await axiosDS({ timeout: 0 }).patch<ArticleModel>(
			`${urls.knowledge.project}/${idProject}/article/${idArticle}`,
			data
		)
		return res.data
	},
	deleteArticleApi: async (idProject: number, idArticle: number) => {
		const res = await axiosDS().delete(
			`${urls.knowledge.project}/${idProject}/article/${idArticle}`
		)
		return res.data
	},
	recoverArticleApi: async (idProject: number, idArticle: number) => {
		const res = await axiosDS().post(
			`${urls.knowledge.project}/${idProject}/article/${idArticle}/recover`
		)
		return res.data
	},
	searchArticleApi: async (params: RequestParams, idProject?: number) => {
		const res = await axiosDS().get<ResponseCatalog<ArticleModel>>(
			`${urls.knowledge.base}/full_text_search`,
			{
				params: {
					...params,
					project_id: idProject,
				},
			}
		)
		return res.data
	},
	getVideoUrl: async (s3FileName: string) => {
		const contour = getContour()
		const base_url =
			contour === CONTOUR.PROD ? urls.knowledge.base_video_url_prod : urls.knowledge.base_video_url
		const res = await axiosDS({ isExternal: true, url: base_url }).get<{ url: string }>(
			urls.knowledge.video_url.replace(':s3FileName', s3FileName)
		)
		return res.data
	},
	getVideoApi: async (projectSlug: string, articleSlug: string) => {
		const res = await axiosDS().get<ArticleModel>(
			urls.knowledge.video.replace(':projectSlug', projectSlug).replace(':articleSlug', articleSlug)
		)
		return res.data
	},
}
